import type { FC } from "react";

import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";

const SkeletonPromotionButtonTypeComponent: FC = () => {
  return (
    <div className="flex w-full items-center gap-4 overflow-auto no-scrollbar">
      {Array.from({ length: 8 }).map((_, index) => {
        return (
          <div
            key={index}
            className="flex h-10 min-w-[120px] items-center justify-center gap-2 rounded-full bg-main-warmGrey-base px-4 last:mr-4 md:w-full"
          >
            <Skeleton className="min-h-6 min-w-6 rounded-full" />
            <Skeleton className="h-5 w-full" />
          </div>
        );
      })}
    </div>
  );
};

export default SkeletonPromotionButtonTypeComponent;
